import type { FC, PropsWithChildren } from "react";

import styles from "./Placeholder.module.scss";

export const Placeholder: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.placeholder}>{children}</div>;
};
